module.exports = "#app-side-details {\n  height: calc(100vh - 56px);\n  overflow-y: auto; }\n"